import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Trash } from '@styled-icons/foundation';
import NotesWrapper from 'apps/exegesis/components/NotesLayout/NotesLayout';
import { LoadingPulser } from 'apps/exegesis/components/StatusUI/LoadingPulser';
import { WidgetSlot, WidgetWrapper } from 'apps/exegesis/components/Widgets/WidgetWrapper';
import { Modal, ModalDark } from 'apps/exegesis/utils/components/Modal';
import { createFetcher, useFetcher } from 'apps/exegesis/utils/DataFetchers';
import { safeNanoid } from 'apps/exegesis/utils/safeNanoid';
import React, { useState } from 'react';
import { useDrop } from 'react-dnd';
import styled from 'styled-components';
import { ErrorDisplay } from '../../components/StatusUI/ErrorDisplay';
import { colors, DarkenMedium, DarkenSlightly, useIsMobile } from '../../styles/themes';
import { queryClient } from '../_app';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  padding: 0px 2.5vw 2.5vw 2.5vw;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  vertical-align: super;\n  margin-left: 1vw;\n  padding: 10px;\n  border: none;\n  border-radius: 10px;\n  color: ",
        ";\n  font-size: 1rem;\n  background-color: ",
        ";\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  height: 200px;\n  width: 200px;\n  background-color: ",
        ";\n  border-radius: 30px;\n  padding: 10px;\n  margin-right: 20px;\n  :hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
export var ItemTypes = {
    WIDGET: 'widget'
};
export var setWidgets = function(newWidgets) {
    createFetcher('SetWidgets')({
        widgets: newWidgets
    });
    queryClient.setQueryData([
        'GetWidgets',
        {}
    ], [
        {
            widgets: newWidgets
        }
    ]);
}; // trashcan
var TrashCan = function(param) {
    var widgets = param.widgets;
    var ref = _slicedToArray(useDrop(function() {
        return {
            accept: ItemTypes.WIDGET,
            drop: function(item) {
                // delete widget
                var newWidgets = _toConsumableArray(widgets);
                var temp = newWidgets[item.index];
                newWidgets.splice(item.index, 1);
                setWidgets(newWidgets);
            },
            collect: function(monitor) {
                return {
                    isOver: !!monitor.isOver(),
                    canDrop: !!monitor.canDrop()
                };
            }
        };
    }, [
        widgets
    ]), 2), ref1 = ref[0], isOver = ref1.isOver, canDrop = ref1.canDrop, drop = ref[1];
    return(/*#__PURE__*/ _jsx(_Fragment, {
        children: canDrop ? /*#__PURE__*/ _jsxs("span", {
            style: {
                verticalAlign: 'super',
                marginLeft: '10px',
                padding: '10px',
                borderRadius: '10px',
                backgroundColor: isOver ? '#a54d4d' : '#f7b1b1'
            },
            ref: drop,
            children: [
                /*#__PURE__*/ _jsx(Trash, {
                    height: "17.5px",
                    style: {
                        verticalAlign: 'sub',
                        color: isOver ? colors.lightOffBlack : '#d47777'
                    }
                }),
                /*#__PURE__*/ _jsx("b", {
                    style: {
                        color: isOver ? colors.lightOffBlack : '#d47777'
                    },
                    children: "Drag here to delete"
                })
            ]
        }) : null
    }));
};
var Dashboard = function() {
    var ref;
    var ref2 = useFetcher([
        'GetWidgets',
        {}
    ], {
        keepPreviousData: true
    }), data = ref2.data, widgetStatus = ref2.status;
    var widgets = data && data.length > 0 ? (ref = data[0]) === null || ref === void 0 ? void 0 : ref.widgets : [];
    var ref3 = useState(false), showWidgetSelector = ref3[0], setShowWidgetSelector = ref3[1];
    var isMobile = useIsMobile();
    return(/*#__PURE__*/ _jsxs(DashboardWrapper, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                style: {
                    marginTop: '1vh'
                },
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        style: {
                            marginBottom: '0px',
                            display: 'inline'
                        },
                        children: "Dashboard"
                    }),
                    /*#__PURE__*/ _jsx(NewWidgetButton, {
                        onClick: function() {
                            setShowWidgetSelector(true);
                        },
                        children: isMobile ? /*#__PURE__*/ _jsx("b", {
                            children: "+"
                        }) : /*#__PURE__*/ _jsx("b", {
                            children: "new widget"
                        })
                    }),
                    /*#__PURE__*/ _jsx(TrashCan, {
                        widgets: widgets
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(WidgetsFlexContainer, {
                children: [
                    widgetStatus === 'loading' ? /*#__PURE__*/ _jsx("div", {
                        style: {
                            height: '100vh',
                            width: '100vw'
                        },
                        children: /*#__PURE__*/ _jsx(LoadingPulser, {})
                    }) : null,
                    widgetStatus === 'error' ? /*#__PURE__*/ _jsx(ErrorDisplay, {}) : null,
                    widgets === null || widgets === void 0 ? void 0 : widgets.map(function(widget, index) {
                        return(/*#__PURE__*/ _jsxs(WidgetSlot, {
                            index: index,
                            widgets: widgets,
                            children: [
                                ' ',
                                /*#__PURE__*/ _jsx(WidgetWrapper, {
                                    widgetData: widget,
                                    widgetUtilityProps: {
                                        index: index,
                                        widgets: widgets
                                    }
                                }),
                                ' '
                            ]
                        }, widget.id));
                    })
                ]
            }),
            showWidgetSelector ? /*#__PURE__*/ _jsx(ModalDark, {
                onClick: function() {
                    setShowWidgetSelector(false);
                },
                children: /*#__PURE__*/ _jsxs(Modal, {
                    children: [
                        /*#__PURE__*/ _jsx("h1", {
                            children: "Add Widget"
                        }),
                        /*#__PURE__*/ _jsxs(WidgetSelector, {
                            children: [
                                /*#__PURE__*/ _jsxs(WidgetSelectorItem, {
                                    onClick: function() {
                                        setWidgets([
                                            {
                                                type: 'BLOCKS_BY_TAGS_WIDGET',
                                                tags: [],
                                                id: safeNanoid()
                                            }
                                        ].concat(_toConsumableArray(widgets)));
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            children: "Block widget"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Shows all blocks with a certain set of tags."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(WidgetSelectorItem, {
                                    onClick: function() {
                                        setWidgets([
                                            {
                                                type: 'NOTES_BY_TAGS_WIDGET',
                                                tags: [],
                                                id: safeNanoid()
                                            }
                                        ].concat(_toConsumableArray(widgets)));
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            children: "Note widget"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Shows all notes with a certain set of tags."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(WidgetSelectorItem, {
                                    onClick: function() {
                                        setWidgets([
                                            {
                                                type: 'PINNED_TAGS_WIDGET',
                                                id: safeNanoid(),
                                                tags: []
                                            }
                                        ].concat(_toConsumableArray(widgets)));
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("h2", {
                                            children: "Pinned tags widget"
                                        }),
                                        /*#__PURE__*/ _jsx("p", {
                                            children: "Shows a pinned set of tags."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }) : null
        ]
    }));
};
var DashboardWrapper = styled.div(_templateObject());
var WidgetsFlexContainer = styled.div(_templateObject1());
var NewWidgetButton = styled.button(_templateObject2(), colors.lightOffBlack, DarkenSlightly, DarkenMedium);
var WidgetSelector = styled.div(_templateObject3());
var WidgetSelectorItem = styled.div(_templateObject4(), DarkenSlightly, DarkenMedium);
Dashboard.layout = NotesWrapper;
export default Dashboard;
